<script lang="ts" setup>
import { IconEmoji, IconGif, capitalize, userAgentInfo } from '#shared'

const {
  isEmojiSelectOpen,
  isGifSelectOpen,
  variant = 'regular',
} = defineProps<{
  isEmojiSelectOpen: boolean
  isGifSelectOpen: boolean
  variant?: 'regular' | 'compact'
  contentEl: HTMLElement | null
}>()

const emit = defineEmits<{
  'emoji-select-toggle': []
  'gif-select-toggle': []
  'emoji-select-close': []
  'gif-select-close': []
}>()

const onEmojiSelectActionClick = () => {
  if (userAgentInfo.isTouchScreen) return
  emit('emoji-select-toggle')
}
const onEmojiSelectActionFocus = (event: Event) => {
  if (!userAgentInfo.isTouchScreen) return
  event.preventDefault()
  emit('emoji-select-toggle')
}

const onGifSelectActionClick = () => {
  if (userAgentInfo.isTouchScreen) return
  emit('gif-select-toggle')
}
const onGifSelectActionFocus = (event: Event) => {
  if (!userAgentInfo.isTouchScreen) return
  event.preventDefault()
  emit('gif-select-toggle')
}
</script>

<template>
  <div :class="$style.root">
    <button
      :class="[
        $style.action,
        $style['actionVariant' + capitalize(variant)],
        { [$style.actionActive]: isGifSelectOpen },
      ]"
      @click="onGifSelectActionClick"
      @touchstart="onGifSelectActionFocus"
    >
      <IconGif />
    </button>

    <button
      :class="[
        $style.action,
        $style['actionVariant' + capitalize(variant)],
        {
          [$style.actionActive]: isEmojiSelectOpen,
        },
      ]"
      @click="onEmojiSelectActionClick"
      @touchstart="onEmojiSelectActionFocus"
    >
      <IconEmoji />
    </button>
  </div>
</template>

<style lang="scss" module>
@use './mixins.scss' as *;
@use '#mixins/media' as media;

.root {
  height: fit-content;
  padding: 0px 3px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.action {
  @include input-action;

  @include media.mobile {
    @include input-action-compact;
  }
}

.actionVariantCompact {
  @include input-action-compact;
}

.actionActive {
  color: white;
}
</style>
